/* Finite, progressive entry motion. Product links never move: only the image layers do. */
if (!customElements.get('guya-assortment')) {
  customElements.define('guya-assortment', class extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.running = new Set();
      this.played = new WeakSet();
      this.onMotion = () => { if (this.motion.matches) this.stop(); };
      this.onVisibility = () => {
        this.running.forEach(animation => document.hidden ? animation.pause() : animation.play());
      };
      this.motion.addEventListener('change', this.onMotion);
      document.addEventListener('visibilitychange', this.onVisibility);
      if (!window.IntersectionObserver || !Element.prototype.animate) return;
      this.observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (!entry.isIntersecting || this.motion.matches || document.hidden || this.played.has(entry.target)) return;
        this.played.add(entry.target);
        entry.target.querySelectorAll('.ga-pack').forEach((image, index) => {
          const animation = image.animate([
            { transform: 'translateY(18px) rotate(-2deg)' },
            { transform: 'translateY(-3px) rotate(.4deg)', offset: .75 },
            { transform: 'none' }
          ], { duration: 1000, delay: index * 90, easing: 'cubic-bezier(.2,.7,.2,1)', iterations: 1 });
          this.running.add(animation);
          animation.finished.then(() => this.running.delete(animation), () => this.running.delete(animation));
        });
        this.observer.unobserve(entry.target);
      }), { threshold: .35 });
      this.querySelectorAll('.ga-lane').forEach(lane => this.observer.observe(lane));
    }
    stop() { this.running?.forEach(animation => animation.cancel()); this.running?.clear(); }
    disconnectedCallback() {
      this.stop(); this.observer?.disconnect(); this.observer = null;
      this.motion?.removeEventListener('change', this.onMotion);
      document.removeEventListener('visibilitychange', this.onVisibility);
    }
  });
}
